module.exports = "<%= Localizer.localize(message, args) %>\n<a href=\"#\" id=\"alert\"><%- Localizer.localize('course_map_alert_dismiss') %></a>\n";